import styled from "styled-components";

export const DownloadContainer = styled.div`
  margin: auto;
  max-width: 860px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  @media (max-width: 490px) {
    margin-bottom: 10px;
  }
`;
